<template>
	<div>
        <router-view @childrenRoute="hideNonChildren" />
		<div class="row px-2 py-2 m-0" v-if="!isChildRoute">
			<div class="col-md-12 p-0">
				<el-card shadow="hover" class="box-card col-md-12 mb-0" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>POST MORTEM</strong></span>
					</div>
					<div>
						<div class="mb-3" style="margin-top:-20px;">
                            <div class="row">
                                <div class="col-md-12">

                                    <el-form  class="mt-2 demo-dynamic" label-position="top" label-width="100px" :inline="true">

                                        <el-form-item label="Tahun">
                                            <el-select v-model="year" filterable placeholder="Select Year" size="small">
                                                <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>

                                        <el-form-item label="Bulan">
                                            <el-select v-model="month" filterable placeholder="Select Month" size="small">
                                                <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>

                                        <el-form-item label="Current/YTD">
                                            <el-radio-group v-model="showperiodtype" size="small">
                                                <el-radio-button label="current">CURRENT</el-radio-button>
                                                <el-radio-button label="ytd">YTD</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>

                                        <el-form-item label="Sales Area">
                                            <el-radio-group v-model="salesarea" size="small" name="group">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>

                                        <el-form-item label="Category">
                                            <el-radio-group v-model="category" size="small" name="group">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.category" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>

                                        <el-form-item v-if="false">
                                            <el-button size="medium" :loading="loading.table" @click="applyFilter">Konsol</el-button>
                                        </el-form-item>

                                    </el-form>
                                </div>
                            </div>

                            <div class="row" v-if="showchart">
                                <div class="col-md-12 mb-0">
                                    <el-radio-group v-model="charttype" size="small">
                                        <el-radio-button :label="'barchart'">Barchart</el-radio-button>
                                        <el-radio-button :label="'linechart'">Linechart</el-radio-button>
                                    </el-radio-group>

                                    <el-radio-group v-model="stacked" size="small" class="ms-3" v-if="charttype=='barchart'">
                                        <el-radio-button :label="false">Parallel</el-radio-button>
                                        <el-radio-button :label="true">Stack</el-radio-button>
                                    </el-radio-group>

                                    <el-radio-group v-model="valuetype" size="small" class="ms-3">
                                        <el-radio-button :label="'fs'">Feasibility Study</el-radio-button>
                                        <el-radio-button :label="'realisasi'">Realisasi</el-radio-button>
                                        <el-radio-button :label="'percentage'">Persentase Realisasi</el-radio-button>
                                    </el-radio-group>
                                </div>
                                <div class="col-md-12 mb-4"  v-if="showchart">
                                    <BarChart v-loading.body="loading.table" :data="barchart" :width="500" :height="350" v-if="charttype=='barchart'"  />
                                    <LineChart v-loading.body="loading.table" :data="barchart" :width="500" :height="140" v-if="charttype=='linechart'"  class="mt-4" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 mb-1 mt-1">
                                    <el-checkbox v-model="showchart">Show Chart</el-checkbox>
                                </div>
                                <div class="col-md-6 mb-1 text-right">
                                    <el-button size="medium" type="primary" :loading="loading.table" @click="exportToHTML">Export to Excel</el-button>
                                </div>
                            </div>
                            <div class="table-post-mortem-container">
                                <table class="table-post-mortem">
                                    <thead class="top-header-1">
                                        <tr>
                                            <th rowspan="2" style="width:60px;background: #edf2f7;z-index:3;"><input type="checkbox" class="app-checkbox" v-model="allChecked" @change="toggleAll($event)" /> <el-checkbox v-model="allChecked" @change="toggleAll" v-if="false"></el-checkbox></th>
                                            <th rowspan="2" style="background: #edf2f7;z-index:3;">Unit/Lokasi</th>
                                            <th :colspan="category != 'fuel' ? '4' : '3'" class="bg-ps-orange1">Sales {{ category=='fuel' ? 'Volume KL/Day':'' }}</th>
                                            <th :colspan="'3'" class="bg-ps-orange2" v-if="category != 'fuel'">COGS</th>
                                            <th :colspan="category != 'bright' ? '3' : '4'" class="bg-ps-green">Gross Margin</th>
                                            <th colspan="3" class="bg-ps-orange2">Opex</th>
                                            <th colspan="3" class="bg-ps-grey">Depresiasi</th>
                                            <th colspan="3" class="bg-ps-pink">Earning After Tax</th>
                                            <th colspan="4" class="bg-ps-orange1" v-if="category=='bright'">Service Level</th>
                                        </tr>
                                        <tr>
                                            <th class="bg-ps-orange1" style="z-index: 1; border-radius:0px;">FS Sales</th>
                                            <th class="bg-ps-orange1">Realisasi</th>
                                            <th class="bg-ps-orange1">% Real</th>
                                            <th class="bg-ps-orange1" v-if="category != 'fuel'">SPD</th>

                                            <th class="bg-ps-orange2" v-if="category != 'fuel'">FS COGS</th>
                                            <th class="bg-ps-orange2" v-if="category != 'fuel'">Realisasi</th>
                                            <th class="bg-ps-orange2" v-if="category != 'fuel'">% Real</th>

                                            <th class="bg-ps-green">FS GM</th>
                                            <th class="bg-ps-green">Realisasi</th>
                                            <th class="bg-ps-green">% Real</th>
                                            <th class="bg-ps-green" v-if="category=='bright'">GPM</th>

                                            <th class="bg-ps-orange2">FS Opex</th>
                                            <th class="bg-ps-orange2">Realisasi</th>
                                            <th class="bg-ps-orange2">% Real</th>

                                            <th class="bg-ps-grey">FS Depresiasi</th>
                                            <th class="bg-ps-grey">Realisasi</th>
                                            <th class="bg-ps-grey">% Real</th>

                                            <th class="bg-ps-pink">FS EAT</th>
                                            <th class="bg-ps-pink">Realisasi</th>
                                            <th class="bg-ps-pink" style="border-radius: 0px">% Real</th>

                                            <th class="bg-ps-orange1" v-if="category=='bright'">To Branch</th>
                                            <th class="bg-ps-orange1" v-if="category=='bright'">PB Qty</th>
                                            <th class="bg-ps-orange1" v-if="category=='bright'">Trans Qty</th>
                                            <th class="bg-ps-orange1" v-if="category=='bright'" style="border-radius: 0px">% Complete Order</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in reportdata?.data" :key="item.Id">
                                            <td class="text-center"><input type="checkbox" class="app-checkbox" v-model="checkedItemsId" :value="item.Id" @change="handleCheckboxItemChange(item, $event)"/><el-checkbox v-model="checkedItemsId" :label="item.Id" @change="handleCheckboxItemChange(item, $event)" v-if="false"></el-checkbox></td>
                                            <td>{{ item?.UnitName }}</td>

                                            <td class="text-right">{{ formatNum(item?.FSSales) }}</td>
                                            <td class="text-right">{{ formatNum(item?.SalesRealisasi) }}</td>
                                            <td class="text-right">{{ formatNum(item?.SalesRealisasiPercentage) }}%</td>
                                            <td class="text-right" v-if="category != 'fuel'">{{ formatNum(item?.SPD) }}</td>

                                            <td class="text-right" v-if="category != 'fuel'">{{ formatNum(item?.FSCogs) }}</td>
                                            <td class="text-right" v-if="category != 'fuel'">{{ formatNum(item?.Cogs) }}</td>
                                            <td class="text-right" v-if="category != 'fuel'">{{ formatNum(item?.CogsRealisasiPercentage) }}%</td>

                                            <td class="text-right">{{ formatNum(item?.FSGM) }}</td>
                                            <td class="text-right">{{ formatNum(item?.GrossProfitRealisasi) }}</td>
                                            <td class="text-right">{{ formatNum(item?.GrossProfitRealisasiPercentage) }}%</td>
                                            <td class="text-right" v-if="category=='bright'">{{ formatNum(item?.GPM) }}%</td>

                                            <td class="text-right">{{ formatNum(item?.FSOpex) }}</td>
                                            <td class="text-right">{{ formatNum(item?.OpexRealisasi) }}</td>
                                            <td class="text-right">{{ formatNum(item?.OpexRealisasiPercentage) }}%</td>

                                            <td class="text-right">{{ formatNum(item?.FSDepresiasi) }}</td>
                                            <td class="text-right">{{ formatNum(item?.DepresiasiRealisasi) }}</td>
                                            <td class="text-right">{{ formatNum(item?.DepresiasiRealisasiPercentage) }}%</td>

                                            <td class="text-right">{{ formatNum(item?.FSEAT) }}</td>
                                            <td class="text-right">{{ formatNum(item?.EatRealisasi) }}</td>
                                            <td class="text-right">{{ formatNum(item?.EatRealisasiPercentage) }}%</td>

                                            <td class="text-right" v-if="category=='bright'">{{ item?.ToBranchName }}</td>
                                            <td class="text-right" v-if="category=='bright'">{{ formatNum(item?.PBQty) }}</td>
                                            <td class="text-right" v-if="category=='bright'">{{ formatNum(item?.TransQty) }}</td>
                                            <td class="text-right" v-if="category=='bright'">{{ formatNum(item?.CompleteOrderinPercentage) }}%</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th></th>
                                            <th class="text-center">AVERAGE</th>

                                            <th class="text-right">{{ formatNum(averages.FSSales, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.SalesRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.SalesRealisasiPercentage, 2) }}%</th>
                                            <th class="text-right" v-if="category != 'fuel'">{{ formatNum(averages.SPD, 2) }}</th>

                                            <th class="text-right" v-if="category != 'fuel'">{{ formatNum(averages.FSCogs, 2) }}</th>
                                            <th class="text-right" v-if="category != 'fuel'">{{ formatNum(averages.Cogs, 2) }}</th>
                                            <th class="text-right" v-if="category != 'fuel'">{{ formatNum(averages.CogsRealisasiPercentage, 2) }}%</th>

                                            <th class="text-right">{{ formatNum(averages.FSGM, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.GrossProfitRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.GrossProfitRealisasiPercentage, 2) }}%</th>
                                            <th class="text-right" v-if="category=='bright'">{{ formatNum(averages.GPM, 2) }}</th>

                                            <th class="text-right">{{ formatNum(averages.FSOpex, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.OpexRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.OpexRealisasiPercentage, 2) }}%</th>

                                            <th class="text-right">{{ formatNum(averages.FSDepresiasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.DepresiasiRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.DepresiasiRealisasiPercentage, 2) }}%</th>

                                            <th class="text-right">{{ formatNum(averages.FSEAT, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.EatRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(averages.EatRealisasiPercentage, 2) }}%</th>

                                            <th class="text-right" v-if="category=='bright'"></th>
                                            <th class="text-right" v-if="category=='bright'">{{ formatNum(averages.PBQty, 2) }}</th>
                                            <th class="text-right" v-if="category=='bright'">{{ formatNum(averages.TransQty, 2) }}</th>
                                            <th class="text-right" v-if="category=='bright'">{{ formatNum(averages.CompleteOrderinPercentage, 2) }}%</th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th class="text-center">TOTAL</th>

                                            <th class="text-right">{{ formatNum(totals.FSSales, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.SalesRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.SalesRealisasiPercentage, 2) }}%</th>
                                            <th class="text-right" v-if="category != 'fuel'">{{ formatNum(totals.SPD, 2) }}</th>

                                            <th class="text-right" v-if="category != 'fuel'">{{ formatNum(totals.FSCogs, 2) }}</th>
                                            <th class="text-right" v-if="category != 'fuel'">{{ formatNum(totals.Cogs, 2) }}</th>
                                            <th class="text-right" v-if="category != 'fuel'">{{ formatNum(totals.CogsRealisasiPercentage, 2) }}%</th>

                                            <th class="text-right">{{ formatNum(totals.FSGM, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.GrossProfitRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.GrossProfitRealisasiPercentage, 2) }}%</th>
                                            <th class="text-right" v-if="category=='bright'">{{ formatNum(totals.GPM, 2) }}</th>

                                            <th class="text-right">{{ formatNum(totals.FSOpex, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.OpexRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.OpexRealisasiPercentage, 2) }}%</th>

                                            <th class="text-right">{{ formatNum(totals.FSDepresiasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.DepresiasiRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.DepresiasiRealisasiPercentage, 2) }}%</th>

                                            <th class="text-right">{{ formatNum(totals.FSEAT, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.EatRealisasi, 2) }}</th>
                                            <th class="text-right">{{ formatNum(totals.EatRealisasiPercentage, 2) }}%</th>

                                            <th class="text-right" v-if="category=='bright'"></th>
                                            <th class="text-right" v-if="category=='bright'">{{ formatNum(totals.PBQty, 2) }}</th>
                                            <th class="text-right" v-if="category=='bright'">{{ formatNum(totals.TransQty, 2) }}</th>
                                            <th class="text-right" v-if="category=='bright'">{{ formatNum(totals.CompleteOrderinPercentage, 2) }}%</th>
                                        </tr>
                                    </tfoot>
                                </table>
                                <Loader v-if="loading.table" />
                            </div>
						</div>
					</div>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>

import Customer from '@/components/page/Customer.js'
import CustomerReportTab from '@/views/pages/CustomerReportTab.vue'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'
import BarChart from '@/components/chart/BarChart.js'
import LineChart from '@/components/chart/LineChart.js'

import ExcelExporter from '@/views/pages/PostMortem/ExcelExporter.js';

export default
{
	extends: Customer,
	components: {
        Loader,
		BarChart,
        LineChart,
	},

	data(){
		return {
            isChildRoute: false,
            checked: true,
            reportdata: {
                data: [],
            },

            checkedItemsId: [],
            checkedItemsData: [],
            allChecked: true,

            year: Penanggalan().tahun,
            month: Penanggalan().bulan,
            salesarea: '',
            category: 'bright',
            showperiodtype: 'ytd',

            showchart: false,
            barchart: [],
            charttype : 'barchart',
            stacked: false,
            valuetype: 'fs',

            options: {
                months:[
                    //{value:'', name: 'Ytd'},
                    {value:1, name: 'Januari'},
                    {value:2, name: 'Februari'},
                    {value:3, name: 'Maret'},
                    {value:4, name: 'April'},
                    {value:5, name: 'Mei'},
                    {value:6, name: 'Juni'},
                    {value:7, name: 'Juli'},
                    {value:8, name: 'Agustus'},
                    {value:9, name: 'September'},
                    {value:10, name: 'Oktober'},
                    {value:11, name: 'November'},
                    {value:12, name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                ],
                area: [
                    {value:'', name: 'All'},
                    {value:'1', name: '1'},
                    {value:'2', name: '2'},
                    {value:'3', name: '3'},
                    {value:'4', name: '4'},
                    {value:'5', name: '5'},
                ],
                category: [
                   // {value:'', name: 'All'},
                    {value:'bright', name: 'Bright'},
                    {value:'fuel', name: 'Fuel'},
                    {value:'lpg', name: 'LPG'},
                ],
            },

			loading: {
				table : false,
                isSuccess: false,
			},


			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0',
			tabList:[
				{label:'Sales B2B', name: 'sales_b2b', index: '0' },
				{label:'Piutang', name: 'piutang', index: '1' },
			],

            tableData: [
                { name: 'John Doe', age: 28, occupation: 'Developer', city: 'New York' },
                { name: 'Jane Doe', age: 32, occupation: 'Designer', city: 'San Francisco' },
                { name: 'Sam Smith', age: 25, occupation: 'Product Manager' }
            ]
		}
	},
	watch:
	{
        $route(to, from) {
            this.hideNonChildren();
        },
        year() {
            this.getData();
        },
        month()  {
            this.getData();
        },
        salesarea() {
            this.getData();
        },
        category() {
            this.getData();
        },
        showperiodtype() {
            this.getData();
        },

        valuetype() {
            this.setBarchart();
        },
        stacked() {
            this.setBarchart();
        }
	},
    mounted()
    {
        this.$emit('childrenRoute');
        this.hideNonChildren();
        this.getData();
    },
    /*
    computed: {
		totalFSSales() {
			return this.reportdata.data.reduce((sum, item) => sum + parseFloat(item.FSSales), 0);
		},

        //Average
        averageFSSales() {
            const totalItems = this.reportdata.data.length;
            return totalItems > 0 ? parseFloat((this.totalFSSales / totalItems)) : 0;
        }
	},
    */
    computed: {
        totals() {
            return {
                FSSales: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.FSSales || 0), 0),
                SalesRealisasi: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.SalesRealisasi || 0), 0),
                SalesRealisasiPercentage: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.SalesRealisasiPercentage || 0), 0),
                SPD: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.SPD || 0), 0),
                FSCogs: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.FSCogs || 0), 0),
                Cogs: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.Cogs || 0), 0),
                CogsRealisasiPercentage: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.CogsRealisasiPercentage || 0), 0),
                FSGM: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.FSGM || 0), 0),
                GrossProfitRealisasi: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.GrossProfitRealisasi || 0), 0),
                GrossProfitRealisasiPercentage: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.GrossProfitRealisasiPercentage || 0), 0),
                GPM: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.GPM || 0), 0),
                FSOpex: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.FSOpex || 0), 0),
                OpexRealisasi: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.OpexRealisasi || 0), 0),
                OpexRealisasiPercentage: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.OpexRealisasiPercentage || 0), 0),
                FSDepresiasi: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.FSDepresiasi || 0), 0),
                DepresiasiRealisasi: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.DepresiasiRealisasi || 0), 0),
                DepresiasiRealisasiPercentage: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.DepresiasiRealisasiPercentage || 0), 0),
                FSEAT: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.FSEAT || 0), 0),
                EatRealisasi: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.EatRealisasi || 0), 0),
                EatRealisasiPercentage: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.EatRealisasiPercentage || 0), 0),
                PBQty: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.PBQty || 0), 0),
                TransQty: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.TransQty || 0), 0),
                CompleteOrderinPercentage: this.checkedItemsData.reduce((sum, item) => sum + parseFloat(item.CompleteOrderinPercentage || 0), 0),
            };
        },

        averages() {
            const totalItems = this.checkedItemsData.length;
            return {
                FSSales: totalItems > 0 ? parseFloat((this.totals.FSSales / totalItems).toFixed(2)) : 0,
                SalesRealisasi: totalItems > 0 ? parseFloat((this.totals.SalesRealisasi / totalItems).toFixed(2)) : 0,
                SalesRealisasiPercentage: totalItems > 0 ? parseFloat((this.totals.SalesRealisasiPercentage / totalItems).toFixed(2)) : 0,
                SPD: totalItems > 0 ? parseFloat((this.totals.SPD / totalItems).toFixed(2)) : 0,
                FSCogs: totalItems > 0 ? parseFloat((this.totals.FSCogs / totalItems).toFixed(2)) : 0,
                Cogs: totalItems > 0 ? parseFloat((this.totals.Cogs / totalItems).toFixed(2)) : 0,
                CogsRealisasiPercentage: totalItems > 0 ? parseFloat((this.totals.CogsRealisasiPercentage / totalItems).toFixed(2)) : 0,
                FSGM: totalItems > 0 ? parseFloat((this.totals.FSGM / totalItems).toFixed(2)) : 0,
                GrossProfitRealisasi: totalItems > 0 ? parseFloat((this.totals.GrossProfitRealisasi / totalItems).toFixed(2)) : 0,
                GrossProfitRealisasiPercentage: totalItems > 0 ? parseFloat((this.totals.GrossProfitRealisasiPercentage / totalItems).toFixed(2)) : 0,
                GPM: totalItems > 0 ? parseFloat((this.totals.GPM / totalItems).toFixed(2)) : 0,
                FSOpex: totalItems > 0 ? parseFloat((this.totals.FSOpex / totalItems).toFixed(2)) : 0,
                OpexRealisasi: totalItems > 0 ? parseFloat((this.totals.OpexRealisasi / totalItems).toFixed(2)) : 0,
                OpexRealisasiPercentage: totalItems > 0 ? parseFloat((this.totals.OpexRealisasiPercentage / totalItems).toFixed(2)) : 0,
                FSDepresiasi: totalItems > 0 ? parseFloat((this.totals.FSDepresiasi / totalItems).toFixed(2)) : 0,
                DepresiasiRealisasi: totalItems > 0 ? parseFloat((this.totals.DepresiasiRealisasi / totalItems).toFixed(2)) : 0,
                DepresiasiRealisasiPercentage: totalItems > 0 ? parseFloat((this.totals.DepresiasiRealisasiPercentage / totalItems).toFixed(2)) : 0,
                FSEAT: totalItems > 0 ? parseFloat((this.totals.FSEAT / totalItems).toFixed(2)) : 0,
                EatRealisasi: totalItems > 0 ? parseFloat((this.totals.EatRealisasi / totalItems).toFixed(2)) : 0,
                EatRealisasiPercentage: totalItems > 0 ? parseFloat((this.totals.EatRealisasiPercentage / totalItems).toFixed(2)) : 0,
                PBQty: totalItems > 0 ? parseFloat((this.totals.PBQty / totalItems).toFixed(2)) : 0,
                TransQty: totalItems > 0 ? parseFloat((this.totals.TransQty / totalItems).toFixed(2)) : 0,
                CompleteOrderinPercentage: totalItems > 0 ? parseFloat((this.totals.CompleteOrderinPercentage / totalItems).toFixed(2)) : 0,
            };
        },

        /*
        allChecked: {
            get() {
                return this.reportdata.data.length === this.checkedItemsId.length;
            },
            set(value) {
                if (value) {
                    this.checkedItemsId = [...this.reportdata.data]; //this.reportdata.data.slice();  // Centang semua item
                } else {
                    this.checkedItemsId = [];  // Hapus semua centang
                }
            }
        }
        */
    },

    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/post-mortem';
            //this.isChildRoute = this.$route.path !== '/post-mortem/performance';
        },

        async getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/postmortem/detail?'

            this.urlRequestParams += '&year='+this.year
			this.urlRequestParams += '&month='+this.month
			this.urlRequestParams += '&area='+this.salesarea
			this.urlRequestParams += '&category='+this.category
			this.urlRequestParams += '&showperiodtype='+this.showperiodtype


            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.reportdata = response.data;

                    this.setBarchart();

                    this.clearCheckedItems();
                    this.addAllItems();

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

        setBarchart() {
            //console.log('this.maindata: ' + JSON.stringify(this.maindata))
            let label = 'UnitName'
            let value = 'FSValue'
            let legend = 'FSType'

            if(this.valuetype=='realisasi') {
                value = 'RealisasiValue';
            } else if(this.valuetype=='percentage') {
                value = 'PercentageValue';
            }

            this.barchart = this.processBarChart(this.reportdata.chart, legend, '', value, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);
        },

		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

        exportToHTML() {
            let title = this.showperiodtype + ' ' + this.getMonthName(this.month) + ' ' + this.year;
            const exporter = new ExcelExporter();
            if(this.category == 'bright')
                exporter.exportBrightToHTML(this.checkedItemsData, 'Post Mortem Bright '+ title, this.totals, this.averages);
            else if(this.category == 'fuel')
                exporter.exportFuelToHTML(this.checkedItemsData, 'Post Mortem Fuel ' + title, this.totals, this.averages);
            else if(this.category == 'lpg')
                exporter.exportLpgToHTML(this.checkedItemsData, 'Post Mortem LPG ' + title, this.totals, this.averages);
            /*
            // 1. Buat string HTML tabel dengan CSS styling
            let htmlContent = `
                <html>
                <head>
                <style>
                    table {
                    width: 100%;
                    border-collapse: collapse;
                    }
                    th, td {
                    border: 1px solid black;
                    padding: 8px;
                    text-align: left;
                    }
                    th {
                    background-color: #f2f2f2;
                    }
                    .highlight {
                    background-color: #ffeb3b;
                    }
                </style>
                </head>
                <body>
                <table>
                    <thead>
                    <tr>
                        <th rowspan="2">Name</th>
                        <th colspan="2">Details</th>
                    </tr>
                    <tr>
                        <th>Age</th>
                        <th>Occupation</th>
                    </tr>
                    </thead>
                    <tbody>
            `;

            // 2. Tambahkan data table ke HTML dengan CSS class untuk background
            this.tableData.forEach(item => {
                htmlContent += `
                <tr>
                    <td class="highlight">${item.name}</td>
                    <td>${item.age}</td>
                    <td>${item.occupation}</td>
                </tr>
                `;
            });

            htmlContent += `
                </tbody>
                </table>
                </body>
                </html>
            `;

            // 3. Buat Blob dari HTML string
            const blob = new Blob([htmlContent], { type: 'application/vnd.ms-excel;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);

            // 4. Buat link download untuk file HTML (yang kompatibel dengan Excel)
            link.setAttribute('href', url);
            link.setAttribute('download', 'DataExport.xls'); // Excel bisa membuka file HTML dengan ekstensi .xls
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            */
        },
        clearCheckedItems() {
            this.checkedItemsId = [];  //clear first
            this.checkedItemsData = [];  //clear first
        },
        addAllItems() {
            this.checkedItemsId = this.reportdata.data.map(item => item.Id);
            this.checkedItemsData = this.reportdata.data.slice() ;
        },
        toggleAll() {
            if(this.allChecked) {
                this.clearCheckedItems();
                this.addAllItems();
            } else {
                this.clearCheckedItems();
            }
            //console.log('this.checkedItemsId: ' + JSON.stringify(this.checkedItemsId));
        },
        handleCheckboxItemChange(data, event) {
            const isChecked = event.target.checked;
            let itemId = data.Id;
            if (isChecked) {
                this.checkedItemsId.push(itemId)
                const existingIndex = this.checkedItemsData.findIndex(item => item.Id === itemId);
                if (existingIndex === -1) {
                    this.checkedItemsData.push(data);
                }
                //console.log('handleCheckboxItemChange checked: ' + JSON.stringify(this.checkedItemsData));
            } else {
                this.checkedItemsId = this.checkedItemsId.filter(item => item !== itemId);
                //remove from array by id
                this.checkedItemsData = this.checkedItemsData.filter(item => item.Id !== itemId);
                //console.log('handleCheckboxItemChange uncheck: ' + JSON.stringify(this.checkedItemsData));
                //this.checkedItemsId = this.selectedRows.filter(item => item !== id)
            }
        },

    }
}
</script>
<style>
.table-post-mortem-container {
  /*max-width: 500px; */
  width: 100%;
  margin: auto;
  margin-top: 0rem;
  overflow-x: auto;
  height: 450px;
}

.table-post-mortem {
  font-family: "Open Sans", sans-serif;
  position: relative;
  border-collapse: initial; /**collapse */
  border-spacing: 0;
  table-layout: auto;
  width: 100%;
  border: none;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  white-space: nowrap;
}

.table-post-mortem thead th {
  /*background: #edf2f7; */ /* $gray-200 */
  padding: 0.45rem 1.5rem;
  vertical-align: middle;
  text-align: center;
  border: 1px solid white;
  border-left: 0px solid white;
  border-top: 0px solid white;
}

.table-post-mortem tfoot th {
  background: #edf2f7;  /* $gray-200 */
  padding: 0.45rem 0.5rem;
  vertical-align: middle;
  text-align: right;
  border: 1px solid white;
  border-left: 0px solid #F0F0F0;
  border-top: 0px solid #F0F0F0;
}

.top-header-1 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 0;
    z-index: 2;
}

.top-header-2 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 70;
    z-index: 2;
}

.table-post-mortem thead th:first-child {
    z-index: 4;
}

.table-post-mortem th:first-child {
  border-top-left-radius: 0.5rem;
}

.table-post-mortem th:last-child {
  border-top-right-radius: 0.5rem;
}


.table-post-mortem thead tr {
  color: #2d3748; /* $gray-800 */
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
}

.table-post-mortem tbody tr:nth-child(odd) td {
  background: #ffffff; /* $white */
}

.table-post-mortem tbody tr:nth-child(even) td {
  background: #FAFBFC /*#edf2f7*/; /* $gray-200 */
}

.table-post-mortem tbody tr:hover {
  background-color: #e2e8f0 !important; /**e2e8f0 */
}

.table-post-mortem tbody tr:hover td {
  background-color: #e2e8f0;
}

.table-post-mortem tbody td {
  color: #1a202c; /* $gray-900 */
  text-align: left;
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
  font-size: 0.925rem;
  font-weight: normal;
  border:1px solid #F0F0F0;
  border-left:0px solid #F0F0F0;
}

.table-post-mortem tr:last-child td:first-child {
  border-bottom-left-radius: 0.5rem;
}

.table-post-mortem tr:last-child td:last-child {
  border-bottom-right-radius: 0.5rem;
}

.table-post-mortem tr > th:first-child,
.table-post-mortem tr > td:first-child {
  position: sticky;
  left: 0;
}

.table-post-mortem tr > th:nth-child(2),
.table-post-mortem tr > td:nth-child(2) {
  position: sticky;
  left: 63px;
}

.bg-ps-orange1 {
    background: #F1A983;
    color: #000000;
}

.bg-ps-green {
    background: #8ED973;
    color: #000000;
}

.bg-ps-orange2 {
    background: #FFC000;
    color: #000000;
}

.bg-ps-grey {
    background: #BFBFBF;
    color: #000000;
}

.bg-ps-pink {
    background: #E49EDD;
    color: #000000;
}

.app-checkbox {
    transform: scale(1.8);
    cursor:pointer;
}

</style>
